import { openDB } from 'idb';

export function useDb() {
  const dbName = 'constructionApp';
  const storeName = 'ca-offline-db';
  const dbPromise = openDB(dbName, 1, {
    upgrade(db) {
      db.createObjectStore(storeName, { keyPath: 'id' });
    },
  });

  async function saveDataToIndexedDB(data: { data: any; id: string }) {
    const db = await dbPromise;
    await db.delete(storeName, data.id);
    await db.put(storeName, data);
  }

  async function getDataFromIndexedDB(key: string) {
    const db = await dbPromise;
    return db.get(storeName, key);
  }

  return { getDataFromIndexedDB, saveDataToIndexedDB };
}
